import React from 'react';
import { getDeliveryCounts } from '../../utils/deliveryDisplay';

const DeliveryOverviewStrip = ({ deliveries, loading = false }) => {
  if (loading) {
    return (
      <div className="delivery-overview-strip mb-4">
        <div className="overview-chip-card skeleton-card"><div className="skeleton-line skeleton-line-short" /></div>
        <div className="overview-chip-card skeleton-card"><div className="skeleton-line skeleton-line-short" /></div>
        <div className="overview-chip-card skeleton-card"><div className="skeleton-line skeleton-line-short" /></div>
      </div>
    );
  }

  const counts = getDeliveryCounts(deliveries);

  return (
    <div className="delivery-overview-strip mb-4">
      <div className="overview-chip-card">
        <span className="overview-chip-label">Orders</span>
        <strong>{counts.total}</strong>
      </div>
      <div className="overview-chip-card">
        <span className="overview-chip-label">Active</span>
        <strong>{counts.active}</strong>
      </div>
      <div className="overview-chip-card">
        <span className="overview-chip-label">Delivered</span>
        <strong>{counts.delivered}</strong>
      </div>
    </div>
  );
};

export default DeliveryOverviewStrip;
